import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=5360e28a&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=ts&"
export * from "./Tab.vue?vue&type=script&lang=ts&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=5360e28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360e28a",
  null
  
)

export default component.exports